<template lang="pug">
#modal-coordenadas-interno
    el-form(label-position='top', ref='ruleForm', :model='formDados')
        el-form-item.radio-tipo(
            prop='tipo',
            :label="$t('mensagens.menuMapa.labels.selecioneFormatoInsercao')"
        )
            el-radio(v-model='formDados.tipo', label='gms')
                | GMS

            el-radio(v-model='formDados.tipo', label='decimal')
                | {{ $t('mensagens.menuMapa.labels.decimal') }}

            el-radio(v-model='formDados.tipo', label='utm')
                | UTM

        .modal-coordenadas-interno--gms(
            v-if='formDados.tipo === "gms"'
        )
            el-form-item(prop='latitude')
                span(slot='label')
                    b {{ $t('mensagens.menuMapa.labels.latitude') }}
                        i(
                            data-toggle="tooltip"
                            data-html="true"
                            :title="latitudeInfo"
                        ).mdi.mdi-alert-circle

                el-input(
                    v-model='formDados.latitude',
                    placeholder='EX: 00º30\'15.50\'\'S',
                    ref='formDadosLatitudeInput'
                )
                span.el-form-item__error(ref='formDadosLatitude')

            el-form-item(prop='longitude')
                span(slot='label')
                    b {{ $t('mensagens.menuMapa.labels.longitude') }}
                        i(
                            data-toggle="tooltip"
                            data-html="true"
                            :title="longitudeInfo"
                        ).mdi.mdi-alert-circle

                el-input(
                    v-model='formDados.longitude',
                    placeholder='EX: 77°01\'23.456\'\'W',
                    ref='formDadosLongitudeInput'
                )
                span.el-form-item__error(ref='formDadosLongitude')

        .modal-coordenadas-interno--decimal(
            v-if='formDados.tipo === "decimal"'
        )
            el-form-item(prop='latitude')
                span(slot='label')
                    b {{ $t('mensagens.menuMapa.labels.latitude') }}
                    i(
                        data-toggle="tooltip"
                        data-html="true"
                        :title="latitudeInfoDecimal"
                    ).mdi.mdi-alert-circle

                el-input(
                    v-model='formDados.latitudeDecimal',
                    placeholder='EX: 35.6895, EX: -35.6895',
                    ref='formDadosLatitudeDecimalInput'
                )
                span.el-form-item__error(
                    ref='formDadosLatitudeDecimal'
                )

            el-form-item(:label="$t('mensagens.menuMapa.labels.longitude')", prop='longitude')
                span(slot='label')
                    b {{ $t('mensagens.menuMapa.labels.longitude') }}
                    i(
                        data-toggle="tooltip"
                        data-html="true"
                        :title="longitudeInfoDecimal"
                    ).mdi.mdi-alert-circle

                el-input(
                    v-model='formDados.longitudeDecimal',
                    placeholder='EX: 13.4050, EX: -13.4050',
                    ref='formDadosLongitudeDecimalInput'
                )
                span.el-form-item__error(
                    ref='formDadosLongitudeDecimal'
                )

        .modal-coordenadas-interno--utm(
            v-if='formDados.tipo === "utm"'
        )
            .modal-coordenadas-interno--utm--bloco
                el-form-item(prop='x')
                    span(slot='label')
                        b X
                        i(
                            data-toggle="tooltip"
                            data-html="true"
                            :title="xInfoUTM"
                        ).mdi.mdi-alert-circle

                    el-input(
                        v-model='formDados.x',
                        placeholder='EX: 35.6895, EX: -35.6895',
                        ref='formDadosXInput'
                    )
                    span.el-form-item__error(ref='formDadosX')

                el-form-item(prop='y')
                    span(slot='label')
                        b Y
                        i(
                            data-toggle="tooltip"
                            data-html="true"
                            :title="yInfoUTM"
                        ).mdi.mdi-alert-circle

                    el-input(
                        v-model='formDados.y',
                        placeholder='EX: 13.4050',
                        ref='formDadosYInput'
                    )
                    span.el-form-item__error(ref='formDadosY')

            .modal-coordenadas-interno--utm--bloco
                el-form-item(label='Fuso', prop='fuso')
                    span(slot='label')
                        b {{ $t('mensagens.menuMapa.labels.fuso') }}
                        i(
                            data-toggle="tooltip"
                            data-html="true"
                            :title="fusoInfoUTM"
                        ).mdi.mdi-alert-circle

                    el-input(
                        v-model='formDados.fuso',
                        placeholder='EX: 28, Ex: 23',
                        ref='formDadosFusoInput'
                    )
                    span.el-form-item__error(ref='formDadosFuso')

                el-form-item(prop='hemisferio')
                    span(slot='label')
                        b {{ $t('mensagens.menuMapa.labels.hemisferio') }}

                    el-select(
                        v-model='formDados.hemisferio',
                        :placeholder="$t('mensagens.comuns.selecione')",
                        ref='formDadosHemisferioInput'
                    )
                        el-option(:label="$t('mensagens.menuMapa.labels.norte')", value='Sul')
                        el-option(:label="$t('mensagens.menuMapa.labels.sul')", value='N')
                    span.el-form-item__error(ref='formDadosHemisferio')
        .btn-footer-modal
            BaseButton(type='primary', @click='submeterCoordenadas()')
                | {{ $t('mensagens.menuMapa.labels.inserirCoordenadas') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalCoordenadas',
    components: {
        BaseButton
    },
    emits: ['dadosFormCoodernadas'],
    props: {
        show: {
            type: Boolean
        }
    },
    data() {
        return {
            formDados: {
                tipo: 'gms',
                latitude: '',
                longitude: '',
                latitudeDecimal: '',
                longitudeDecimal: '',
                x: '',
                y: '',
                hemisferio: '',
                fuso: ''
            },
            latitudeInfo: this.$t('mensagens.menuMapa.labels.exemplos') + ": \n25°30'10.5\"S\n45°10'00\"S\n60°00'00\"S\n72°15'20\"S\n90°00'00\"S\n00°59'30\"S\n18°12'45\"S",
            longitudeInfo: this.$t('mensagens.menuMapa.labels.exemplos') + ": \n77°01'23.456\"W\n122°25'35\"W\n0°00'10.5\"W\n160°30'40\"W\n179°59'59\"W",
            latitudeInfoDecimal: this.$t('mensagens.menuMapa.labels.exemplos') + ': \n37.7749\n-33.8651\n51.5074\n-23.5505\n35.6895',
            longitudeInfoDecimal: this.$t('mensagens.menuMapa.labels.exemplos') + ': \n151.2093\n-122.4194\n13.4050\n-46.6333\n139.6917',
            xInfoUTM: this.$t('mensagens.menuMapa.labels.exemplos') + ': \n327003.39317905717\n-329252.6150966007',
            yInfoUTM: this.$t('mensagens.menuMapa.labels.exemplos') + ': \n4254142.640604802\n11.426539581782349',
            fusoInfoUTM: this.$t('mensagens.menuMapa.labels.exemplos') + ': \n29\n30\n23'
        };
    },
    watch: {
        'formDados.tipo': function () {
            this.reset();
        }
    },
    methods: {
        submeterCoordenadas() {
            if (this.formDados.tipo === 'gms') {
                this.formatGMS();
            } else if (this.formDados.tipo === 'decimal') {
                this.formatDecimal();
            } else {
                this.formatUtm();
            }
        },
        formatGMS() {
            this.resetErro();
            const regexLatitude =
                /^([0-8]?[0-9]|90)°(?:[0-9]|[0-5][0-9])('|′)(?:[0-5][0-9]|60)(?:\.[0-9]+)?("|″)?[NS]$/;
            const regexLongitude =
                /^([0-9]|[0-9][0-9]|1[0-7][0-9]|180)°(?:[0-9]|[0-5][0-9])('|′)(?:[0-5][0-9]|60)(?:\.[0-9]+)?("|″)?[WE]$/;

            this.normalizarCoordenada();
            const latMatch = this.formDados.latitude.match(regexLatitude);
            const longMatch = this.formDados.longitude.match(regexLongitude);

            if (!latMatch) {
                this.$refs.formDadosLatitude.innerText =
                    'Informe uma Latitude X válida.';
            }

            if (!longMatch) {
                this.$refs.formDadosLongitude.innerText =
                    'Informe uma Latitude Y válida.';
            }

            if (!latMatch || !longMatch) {
                throw new Error();
            }

            const dados = {
                tipo: this.formDados.tipo,
                utm: null,
                latitude: {
                    completo: this.formDados.latitude
                },
                longitude: {
                    completo: this.formDados.longitude
                }
            };

            this.$emit('dadosFormCoodernadas', dados);
        },
        formatDecimal() {
            this.resetErro();

            const regexLatitude = /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
            const regexLongitude = /^-?((1[0-7]|[1-9])?\d(\.\d+)?|180(\.0+)?)$/;

            const latMatch =
                this.formDados.latitudeDecimal.match(regexLatitude);
            const longMatch =
                this.formDados.longitudeDecimal.match(regexLongitude);

            if (!latMatch) {
                this.$refs.formDadosLatitudeDecimal.innerText =
                    'Informe uma Latitude válida.';
            }

            if (!longMatch) {
                this.$refs.formDadosLongitudeDecimal.innerText =
                    'Informe uma Longitude válida.';
            }

            if (!latMatch || !longMatch) {
                throw new Error();
            }

            const dados = {
                tipo: this.formDados.tipo,
                utm: null,
                latitude: {
                    completo: this.formDados.latitudeDecimal
                },
                longitude: {
                    completo: this.formDados.longitudeDecimal
                }
            };

            this.$emit('dadosFormCoodernadas', dados);
        },
        formatUtm() {
            this.resetErro();

            const regexCodernadaX =
                /^(\d{6}|\d{7}|\d{8}|\d{9}|\d{10}|\d{11})(\.\d+)?$/;
            const regexCodernadaY = /^(\d{6}|\d{7}|\d{8}|\d{9})(\.\d+)?$/;
            const regeFuso = /^([1-9]|[1-5][0-9]|6[0-9]|[1-9][0-9]{2})$/;

            const xMatch = this.formDados.x.match(regexCodernadaX);
            const yMatch = this.formDados.y.match(regexCodernadaY);
            const fusoMatch = this.formDados.fuso.match(regeFuso);

            if (!xMatch) {
                this.$refs.formDadosX.innerText =
                    this.$t('mensagens.menuMapa.labels.informeCoordenadaXValida');
            }
            if (!yMatch) {
                this.$refs.formDadosY.innerText =
                this.$t('mensagens.menuMapa.labels.informeCoordenadaYValida');
            }
            if (!fusoMatch) {
                this.$refs.formDadosFuso.innerText =
                    this.$t('mensagens.menuMapa.labels.informeFusoValido');
            }
            if (this.formDados.hemisferio === '') {
                this.$refs.formDadosHemisferio.innerText =
                    this.$t('mensagens.menuMapa.labels.selecioneHemisferio');
            }

            if (!xMatch || !yMatch || !fusoMatch) {
                throw new Error();
            }

            const dados = {
                tipo: this.formDados.tipo,
                utm: {
                    fuso: this.formDados.fuso,
                    hemisferio: this.formDados.hemisferio,
                    x: this.formDados.x,
                    y: this.formDados.y
                },
                latitude: {
                    completo: this.formDados.latitude
                },
                longitude: {
                    completo: this.formDados.longitude
                }
            };

            this.$emit('dadosFormCoodernadas', dados);
        },
        normalizarCoordenada() {
            const padrao = /[\u00B0\u02DA\u00BA]/g;

            this.formDados.latitude = this.formDados.latitude
                .replace("''", '"')
                .replace(/\s/g, '')
                .replace(padrao, '°')
                .toUpperCase();
            this.formDados.longitude = this.formDados.longitude
                .replace("''", '"')
                .replace(/\s/g, '')
                .replace(padrao, '°')
                .toUpperCase();
        },
        reset() {
            this.resetCampos();
            this.resetErro();
        },
        resetCampos() {
            this.formDados.latitude = '';
            this.formDados.longitude = '';
            this.formDados.latitudeDecimal = '';
            this.formDados.longitudeDecimal = '';
            this.formDados.hemisferio = '';
            this.formDados.x = '';
            this.formDados.y = '';
            this.formDados.fuso = '';
        },
        resetErro() {
            if (this.$refs.formDadosX) {
                this.$refs.formDadosX.innerText = '';
            }
            if (this.$refs.formDadosY) {
                this.$refs.formDadosY.innerText = '';
            }
            if (this.$refs.formDadosFuso) {
                this.$refs.formDadosFuso.innerText = '';
            }
            if (this.$refs.formDadosLatitude) {
                this.$refs.formDadosLatitude.innerText = '';
            }
            if (this.$refs.formDadosLongitude) {
                this.$refs.formDadosLongitude.innerText = '';
            }
            if (this.$refs.formDadosLatitudeDecimal) {
                this.$refs.formDadosLatitudeDecimal.innerText = '';
            }
            if (this.$refs.formDadosLongitudeDecimal) {
                this.$refs.formDadosLongitudeDecimal.innerText = '';
            }
            if (this.$refs.formDadosHemisferio) {
                this.$refs.formDadosHemisferio.innerText = '';
            }
        }
    }
};
</script>
<style lang="scss">
#modal-coordenadas-interno {
    padding-left: 0.5rem;
    .modal-coordenadas-interno--gms,
    .modal-coordenadas-interno--decimal,
    .modal-coordenadas-interno--utm {
        min-height: 200px;
    }

    .el-input__inner {
        font-size: 11px;
    }

    .btn-footer-modal .el-button{
        width: 100%;
    }
    .radio-tipo .el-form-item__content {
        display: flex;
        justify-content: flex-start;
        .el-radio {
            padding-right: 1rem;
        }
    }
    .el-form--label-top .el-form-item__label {
        padding: 0 0 0 0 !important;
    }
    .el-form-item__label {
        font-size: 15px;
    }

    .modal-coordenadas-interno--utm--bloco {
        display: flex;
        width: 100%;
        padding-bottom: 1.2rem;
        gap: 10px;
    }
    .el-form-item .el-form-item {
        margin-bottom: 20px;
    }
}
</style>
